import { cn } from "@/lib/utils";
import {
  segmentedButton,
  segmentedContainer,
  type ControlSize,
} from "@/components/prices/priceControlStyles";
import { NativeSelect } from "@/components/ui/native-select";

interface Props {
  value: "excl" | "incl";
  onChange: (value: "excl" | "incl") => void;
  size?: ControlSize;
  className?: string;
}

/**
 * Växla mellan pris exklusive och inklusive moms.
 * Desktop: inbyggd select. Mobil: segmenterad toggle.
 */
const VatToggle = ({ value, onChange, size = "sm", className }: Props) => (
  <>
    <div
      className={cn(segmentedContainer(size), "md:hidden", className)}
      role="group"
      aria-label="Välj moms"
    >
      <button
        type="button"
        aria-pressed={value === "excl"}
        onClick={() => onChange("excl")}
        className={segmentedButton(value === "excl", size)}
      >
        Exkl. moms
      </button>
      <button
        type="button"
        aria-pressed={value === "incl"}
        onClick={() => onChange("incl")}
        className={segmentedButton(value === "incl", size)}
      >
        Inkl. moms
      </button>
    </div>

    <NativeSelect
      aria-label="Välj moms"
      value={value}
      onValueChange={(v) => onChange(v as "excl" | "incl")}
      options={[
        { value: "excl", label: "Exkl. moms" },
        { value: "incl", label: "Inkl. moms" },
      ]}
      wrapperClassName={cn("hidden md:inline-flex", className)}
      className={size === "sm" ? "h-9" : "h-10"}
    />
  </>
);

export default VatToggle;
